import React from 'react';
import JoinSuccess from './img/join-success.png'
import senior_img from '@asset/img/advanced.png'
import trial_img from '@asset/img/trial.png'
import profession_img from '@asset/img/profession.png'
import { Flex, ListView, PullToRefresh, Modal,Toast } from 'antd-mobile-v2';
import default_img from '@asset/img/default-company.png';
import { getSameCompanyNameList,joinSend,createCompany } from '@api/company.api';
import { SameCompanyNameRes } from '@typesDef/company.type';
import './file.css'

type Props = {
  location: {
    state: {
      province: string;
      city: string;
      companyType: string;
      companyName: string;
      shortName: string;
      latitude: string;
      longitude: string;
      personId: string;
      phone: string;
    }
  }
}
type State ={
  dataSource:any,
  list: SameCompanyNameRes[],
  pageNo: number,
  isLoading: boolean,
  isListEnd: boolean,
  refreshing: Boolean,
  showSuccessTip: boolean,
  mark: string,
  canRegister:boolean,
}
const VERSION = {
  //1:试用版 2:专业版 3:高级版
  TRIAL_VERSION: '1',
  PROFESSION_VERSION: '2',
  SENIOR_VERSION: '3',
};
const APPLY_STATUS = {
  //0.已加入 1.已申请 2.未加入未申请
  ADD: '0',
  APPLY: '1',
  NO_ADD_NO_APPLY: '2',
};
const VERSION_MAP = new Map([
  [VERSION.TRIAL_VERSION, trial_img],
  [VERSION.PROFESSION_VERSION, profession_img],
  [VERSION.SENIOR_VERSION, senior_img],
]);
class SameNameCompany extends React.Component <Props,State>{
  ds = new ListView.DataSource({
    rowHasChanged: (r1:any, r2:any) => r1 !== r2
  });
  state = {
    dataSource:this.ds,
    list: [],
    pageNo: 1,
    isLoading: false,
    isListEnd: false,
    refreshing: false,
    showSuccessTip: false,
    mark: '',
    canRegister:true,
  }
  pageSize = 10;
  componentDidMount() {
    document.title = '重名公司';
    this.initList();
  }
  initList = async () => {
    const { province, city, companyName,personId } = this.props.location.state;
    if (this.state.isListEnd || this.state.isLoading) return;
    this.setState({ isLoading: true });
    let params = {
      pageNo: this.state.pageNo,
      pageSize:this.pageSize,
      companyName: companyName,
      province: province,
      city: city,
      personId: personId
    }
    let res:SameCompanyNameRes[] = (await getSameCompanyNameList(params)).data.data;
    let oldList = this.state.list.slice();
    // @ts-ignore
    let newList = oldList.concat(res);
    this.setState({
      list: newList,
      isLoading: false,
      pageNo:1+this.state.pageNo,
      isListEnd:res.length < this.pageSize?true:false,
    })
  }

  onRefresh = async () => {
    this.setState({
      refreshing:true,
      list: [],
      isListEnd: false,
      pageNo: 1,
    }, () => {
      this.initList();
      this.setState({
        refreshing:false,
      })
   })
  }

  prompt = Modal.prompt;
  onClickJoin = (companyId:number) => {
    this.prompt('加入公司', '申请备注',
      [
        {
          text: '关闭',
          onPress: value => console.log(value),
        },
        {
          text: '提交',
          onPress: value => {
            if(value.length>15){
              Toast.info('备注最多输入15字');
            } else {
              this.setState({ mark: value }, () => {
                this.submitMark(companyId)
              })
            }
          }
        },
      ], 'default', '', ['请输入备注信息'])
  }
  submitMark = async (companyId: number) => {
    let params = {
      joinPersonId: this.props.location.state.personId,
      remark: this.state.mark,
      companyId:companyId,
    };
    let res = (await joinSend(params)).data;
    if (res.code === '200') {
      let itemIndex = this.state.list.findIndex((item: SameCompanyNameRes) => {
        return item.companyId === companyId;
      });
      let newList = this.state.list.slice();
       // @ts-ignore
      newList[itemIndex].applyStatus = '1';
      this.setState({
        list: newList,
        showSuccessTip: true
      })
    } else {
      Toast.info('啊偶，网络出了点小问题，请联系一起装~');
    }
  }
  registerNewCompany = async () => {
    if (!this.state.canRegister) return;
    this.setState({
      canRegister: false
    });
    const { province, city, companyType,companyName,shortName,latitude,longitude,personId,phone } = this.props.location.state;
    let params = {
      province: province,
      city: city,
      companyType: companyType,
      companyName:companyName,
      shortName: shortName,
      latitude: latitude,
      longitude: longitude,
      personId: personId,
      phone: phone,
    };
    setTimeout(() => {
      this.setState({
        canRegister:true
      })
    }, 5000);
    // @ts-ignore
    await createCompany(params); //创建公司
    Toast.info('注册成功', 1500);
    setTimeout(() => {
      window.location.href = "https://cdn.1qizhuang.com/react_worker/#/downloadApp"
    }, 1500);
  }
  joinSuccess = () => {
    return (
      <div style={styles.successContainer}>
        <Flex justify="center" direction="column">
          <img src={JoinSuccess} style={styles.joinSuccessLogo} alt="logo" />
          <span style={styles.successTitle}>申请成功</span>
        </Flex>
      </div>
    )
  }
  listItem = (item: SameCompanyNameRes) => {
    return (
      <div>
        <Flex style={styles.itemContainer} align="start">
          {item.companyAvatar ?
            <img src={item.companyAvatar} style={styles.companyPhoto} alt="logo" />
            : <img src={default_img} style={styles.companyPhoto} alt="logo" />}
          <Flex style={styles.itemRight} justify='between' align="start">
            <Flex direction="column" align="start">
              <span style={styles.companyName}>{ item.companyName}</span>
              <span style={styles.member}>成员：{ item.memberCount}人</span>
              <img src={VERSION_MAP.get(item.productVersion)} style={styles.version} alt="version" />
            </Flex>
            {(item.applyStatus === APPLY_STATUS.ADD ||
              item.applyStatus === APPLY_STATUS.APPLY) && (
              <Flex style={styles.noButton} justify="center"><span style={styles.noJoin}> {item.applyStatus === APPLY_STATUS.ADD ? '已加入': '已申请'}</span></Flex>
            )}
            {item.applyStatus === APPLY_STATUS.NO_ADD_NO_APPLY && (
              <Flex
                justify="center"
                style={styles.button}
                onClick={() => {
                  this.onClickJoin(item.companyId)
                }}
               >
                <span style={styles.join}>加入</span>
              </Flex>
            )}
          </Flex>
        </Flex>
        <div style={styles.line}></div>
      </div>
    )
  }
  render() {
    return (
      <div>
        {this.state.showSuccessTip ? this.joinSuccess()
          :
          <div>
            <Flex style={styles.tipContainer} align="center" className="tip_container"> 
              <span style={styles.tip}>
                {this.props.location.state.province}
                {this.props.location.state.city}
                已存在同名公司，是否要加入？如需继续注册新公司,<span style={styles.clickRegister} onClick={this.registerNewCompany}>点我注册{'>'}</span></span>
            </Flex>
            <div style={{height:40}}></div>
            <ListView
              style={{background:"white",height:"100vh"}}
              dataSource={this.state.dataSource.cloneWithRows(this.state.list)}
              renderRow={(rowData) => this.listItem(rowData)}
              initialListSize={10}
              pageSize={10}
              renderFooter={() => (
                <div style={{ paddingTop: 30,paddingBottom:150, textAlign: 'center' }}>
                  {this.state.isLoading ? '加载中...' : '没有更多数据'}
                </div>
              )}  
              useBodyScroll={true}
              pullToRefresh={
                // @ts-ignore
                <PullToRefresh  
                  direction="down"
                  distanceToRefresh={3}
                  getScrollContainer={()=>undefined} 
                  refreshing={this.state.refreshing}
                  onRefresh={() => { this.onRefresh()}}
                />}
              onEndReached={() => { this.initList() }}
              onEndReachedThreshold={10}
            />
          </div>
        }
      </div>
    ) 
  }
};
const styles = {
  tipContainer: {
    height: 40,
    backgroundColor: '#eef5ff',
  },
  tip: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.3,
  },
  clickRegister: {
    color: '#0067ff',
  },
  companyPhoto: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 3,
    borderColor:'red',
  },
  itemContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15,
  },
  itemRight: {
    marginLeft: 15,
    width: '100%',
  },
  companyName: {
    fontSize: 16,
    fontWeight: 500,
    color: '#444444',
    lineHeight: 1.37,
    maxWidth: '100%',
  },
  member: {
    marginTop:5,
    fontSize: 12,
    fontWeight: 400,
    color: '#9B9B9B',
    lineHeight: 1.37,
  },
  version: {
    width: 55,
    height: 18,
    marginTop:8,
  },
  button: {
    minWidth: 56,
    height: 30,
    marginLeft: 30,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#00BFD1',
    borderRadius: 3,
  },
  noButton: {
    minWidth: 56,
    height: 30,
    marginLeft: 30,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#EFF1F2',
    backgroundColor: '#F7F7F7',
    borderRadius: 3,
  },
  noJoin: {
    fontSize: 12,
    fontWeight: 400,
    color: '#D6D6D6',
  },
  join: {
    fontSize: 12,
    fontWeight: 400,
    color: '#00BFD1',
  },
  line: {
    width: document.body.clientWidth - 85,
    marginLeft:70,
    height: 1,
    backgroundColor:'#EFF1F2',
  },
  successContainer: {
    width: '100vw',
    height: '100vh',
    backgroundColor:'white',
  },
  joinSuccessLogo: {
    width: 210,
    height: 162,
    marginTop:120,
  },
  successTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: '#444444',
    marginTop:30,
  },
  // bottomButtonContainer: {
  //   width: '100%',
  //   height: 76,
  //   bottom: 0,
  //   borderStyle:'solid',
  //   borderTopWidth: 0.5,
  //   borderTopColor: '#EFF1F2',
  //   borderLeftWidth: 0,
  //   borderRightWidth: 0,
  //   borderBottomWidth: 0,
  //   backgroundColor: 'white',
  //   zIndex:10,
  // },
  bottmButton: {
    width: '84%',
  },
  registerTitle: {
    fontSize: 15,
    fontWeight: 500,
    color: '#FFFFFF',
  }
}
export default SameNameCompany;